import AuthAnotherActionBlock from './AuthAnotherActionBlock';

export default AuthAnotherActionBlock;
